import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { EnquadramentoLegalComponent } from './enquadramento-legal.component';
import { EnquadramentoLegalEditComponent } from './enquadramento-legal-edit/enquadramento-legal-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [EnquadramentoLegalComponent, EnquadramentoLegalEditComponent]
})
export class EnquadramentoLegalModule { }
